module.exports = __webpack_public_path__ + "static/img/footer6.96e8b07.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/footer6.png
// module id = mK81
// module chunks = 1